import { utils } from './utils.js';
import { gallery } from './gallery.js';
import { drawer } from './drawer.js';
import { } from '../../node_modules/hc-sticky';
import { tns } from "../../node_modules/tiny-slider/src/tiny-slider";
// import handorgel from "../../node_modules/handorgel/lib/js/esm/handorgel.js";

class Community {

    constructor() {
    }

    init() {

        this.stickyComponents();
        this.scrollToSections();

        this.scroller();

        gallery.init('.-gallery'); // hero section gallery ( main )

        this.bookButton();

        this.communityCardSlider(); // fix me: unable to get property 'parentNode' of undefined or null

        this.accordion();
        this.expandableContent();

    }

    /**
     * handle sticky section navigation as well as the right side contact infor component
     */
    stickyComponents() {

        let self = this;

        // . section-navigation <-- sticky 'Sectioned' navigation
        // Overview | Amenities | Visiting | Image Gallery | Types of Care
        //
        let adminBar = document.querySelector('#wpadminbar'),
            offset = (adminBar != null) ? adminBar.offsetHeight : 0;

        var ccResponsiveOptions = {
            1024: {
                disable: false,
                top: 48 + offset + 24
            }
        }

        var communityCard = new hcSticky('.contact-card', {
            stickTo: '.list-of-sections',
            mobileFirst: true,
            disable: true
        });

        var snResponsiveOptions = {
            640: {
                disable: false
            }
        }

        var sectionNavigation = new hcSticky('.section-navigation', {
            stickTo: '.site-main', // '.template-layout-community',
            mobileFirst: true,
            disable: true, // disable by default then make it stick on medium-up
            responsive: snResponsiveOptions,
            onStart: function () {
                // sticky .... attached... I am sticky now
                var currentOptions = communityCard.options();
                if (currentOptions.responsive == null) {
                    // UPDATING... just needs to be done once
                    currentOptions.responsive = ccResponsiveOptions;
                    communityCard.update(currentOptions);
                    self.scrollSpy();
                }
            },
            onStop: function () {
                // not sticky
                var currentOptions = communityCard.options();
                if (currentOptions.responsive != null) {
                    // UPDATING... just needs to be done once
                    currentOptions.responsive = null;
                    communityCard.update(currentOptions);
                }
            }
        });
    }

    /**
     * handle scrolling to anchored section
     */
    scrollToSections() {

        const self = this;

        const anchors = document.querySelectorAll('.section-navigation a');
        const total = anchors.length;
        if (total > 0) {
            for (var i = 0; i < total; i++) {
                var el = anchors[i];
                el.addEventListener('click', function (e) {
                    e.preventDefault();
                    var scrollToThis = document.getElementsByName(e.target.hash.slice(1));
                    self.scrollTo(scrollToThis[0]);

                    // utils.disableScroll();
                    self.scrollSpy(e.target.hash.slice(1));
                    // utils.enableScroll();
                }, false);
            }
        }

    }

    scrollSpy(clickToActive = '') {

        let self = this;

        let section = document.querySelectorAll('.list-of-sections .section'),
            sections = {},
            i = 0;

        // for each sections, determine the offset top value and collect
        // @todo re-calculate on window resize, take out 50 on mobile
        //
        Array.prototype.forEach.call(section, function (e) {
            // collect offset top
            sections[e.id] = utils.offset(e).top - 50; // sticky navigation height
        });

        if (clickToActive != '') {
            // came here via click
            // let the rest of function handle the scroll spy feature
            return false;
        }

        var anchors = document.querySelectorAll('.section-navigation li a'),
            active = anchors[0].getAttribute('href').replace('#', '');

        window.onscroll = function () {

            var scrollPosition = document.documentElement.scrollTop || document.body.scrollTop;
            for (i in sections) {
                if (sections[i] <= scrollPosition) {
                    // deal with active section "state" changes
                    if (active != i) {
                        let kurrent = document.querySelector('a[id=s-' + active + ']');
                        if (active != i) {
                            // unset the 'active' class from 'previous' active section
                            //
                            utils.removeClass(kurrent, 'active');

                            // set the 'active' section
                            active = i;

                            // set active class on this 'new' active section
                            kurrent = document.querySelector('a[id=s-' + active + ']');
                            utils.addClass(kurrent, 'active')
                        }
                    }
                }
            }

        } // window.onscroll

    } // scrollSpy

    /**
     * given target element, attempt to scroll to the element with sticky and/or fixed elements
     * e.g. WordPress admin bar, sticky sections
     */
    scrollTo(element) {

        const self = this;

        const bodyRect = document.body.getBoundingClientRect();
        const elemRect = element.getBoundingClientRect();
        const offset = Math.round(elemRect.top - bodyRect.top);
        var offsetDiff = 0;
        const sticky1 = document.querySelector('#wpadminbar');
        const sticky2 = document.querySelector('.section-navigation');

        if (sticky1 != null) {
            // adminbar is visible
            offsetDiff += sticky1.offsetHeight + 8;
        } else {
            // adminbar is not visible, we need to put some spacing
            offsetDiff += 32 + 8; // height of the heading e.g. h2
        }
        if (sticky2 != null) {
            offsetDiff += sticky2.offsetHeight;
            offsetDiff += 16;
        }
        window.scroll({
            top: offset - offsetDiff,
            left: 0,
            behavior: 'smooth'
        });
    }

    /**
     * handle sticky CTAs on non desktop resolutions
     *      Community Site Name | Contact Us | Book an Appointment
     *      Contact Us | Book an Appointment
     */
    scroller() {

        const footerCopyright = document.querySelector('footer .copy');
        const stickyCTA = document.querySelector('.sticky-cta');

        if (footerCopyright === null) {
            return false;
        }
        if (stickyCTA === null) {
            return false;
        }

        if (utils.isElementInView(footerCopyright)) {
            utils.removeClass(stickyCTA, '-sticky');
        } else {
            utils.addClass(stickyCTA, '-sticky');
        }
        window.addEventListener('scroll', function (event) {
            if (utils.isElementInView(footerCopyright)) {
                utils.removeClass(stickyCTA, '-sticky');
            } else {
                // sticky!
                utils.addClass(stickyCTA, '-sticky');
            }
        });

    }

    bookButton() {
        let self = this;

        let sidebar = document.querySelector('.right-content');
        if (sidebar == null) {
            return;
        }

        let bookButton = sidebar.querySelector('.contact-card .contact-cta a');
        if (bookButton != null) {
            bookButton.addEventListener('click', function (e) {
                e.preventDefault();
                drawer.resetDrawer();
                utils.addClass(drawer.body, 'js-drawer-open');
                utils.addClass(drawer.drawer, '-open');
                utils.addClass(drawer.drawer, '-centered');
                utils.addClass(drawer.drawer, '-book');
            });
        }
    }

    accordion() {

        let self = this;

        let groupedContent = document.querySelectorAll('.section-types-of-care .handorgel');
        if (groupedContent == null) {
            return;
        }
        Array.prototype.forEach.call(groupedContent, function (gc, i) {
            new handorgel(gc, {
                multiSelectable: false,
                collapsible: true,
                carouselFocus: false
            });
        });

    } // accordion

    expandableContent() {

        let self = this;

        let toggles = document.querySelectorAll('.types-of-care.-resources .resource .read-more a');
        if (toggles == null) {
            return;
        }
        Array.prototype.forEach.call(toggles, function (el, i) {
            el.addEventListener('click', function (e) {
                e.preventDefault();
                let resource = el.parentNode.parentNode;
                utils.toggleClass(resource, 'toggle');
                // focus
                self.scrollTo(resource);
            });
        });

    } // expandableContent;

    /**
     * handle community card slider clicks: e.g. we have clickable slider wrapped around a link
     */
    communityCardSlider() {

        let self = this;

        /*
         * activate sliders
         */
        let sliders = document.querySelectorAll('.card-list .slider');
        if (sliders.length == 0) {
            return;
        }

        // tns breaks on IE11
        var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
        if (isIE11) {
            return;
        }

        // Available events include:
        //  indexChanged, transitionStart, transitionEnd,
        //  newBreakpointStart, newBreakpointEnd,
        //  touchStart, touchMove, touchEnd, dragStart, dragMove and dragEnd.
        Array.prototype.forEach.call(sliders, function (slider, i) {
            let theslider = tns({
                container: '.' + slider.id,
                items: 1,
                slideBy: 'page',
                autoplay: false,
                controls: true,
                controlsText: ['&#10216;', '&#10217;'],
                nav: true,
                navPosition: 'bottom',
                lazyload: true,
                onInit: function () {
                    slider.style.display = 'block';
                }
            });
            theslider.events.on('indexChanged', function (so, eventName) {
                let currentImage = so.slideItems[so.index],
                    realImage = currentImage.getAttribute('data-src');
                if (realImage !== 'null') {
                    var img = new Image();
                    img.src = realImage;
                    img.onload = function () {
                        currentImage.src = realImage;
                    }
                }
            });
        });

        /*
         * handle clicks within .card > a link
         * only activate if we are not clicking on
         * .tns-nav or .tns-nav-active
         */
        let imageLinks = document.querySelectorAll('.card-list.-communities .card > a');
        if (imageLinks.length == 0) {
            return;
        }

        Array.prototype.forEach.call(imageLinks, function (el, i) {
            el.addEventListener('click', function (e) {
                if (utils.hasClass(e.target, 'tns-nav') ||
                    utils.hasClass(e.target, 'tns-nav-active') ||
                    (e.target.dataset.controls == 'next' ||
                        e.target.dataset.controls == 'prev')) {
                    e.preventDefault();
                }
                // e.preventDefault();
            });
        });

        /*
         * handle clicks within .card link
         */
        // let cards = document.querySelectorAll('.card-list.-communities .link');
        // if ( cards.length == 0 ) {
        //     return;
        // }
        // Array.prototype.forEach.call(cards, function(el, i) {
        //     el.addEventListener('click', function(e) {
        //         let foundParent = false;
        //         var targetElement = e.target;
        //         do {
        //             if ( targetElement == null ) {
        //                 return;
        //             }
        //             // traverse up to the DOM until we get find .images .-background
        //             targetElement = targetElement.parentNode;
        //             if ( (targetElement != null) && utils.hasClass(targetElement, 'images') ) {
        //                 // clicking within .image -.communities container
        //                 foundParent = true;
        //                 e.preventDefault();
        //                 return;
        //             }
        //         } while( !foundParent );
        //     });
        // });

    }

} // class Community

// Singleton
export let community = new Community();